
<div styleClass="p-mb-4">
  <div>
    <div class="bloque_kuki" style=" display: flex; flex-direction: column; text-align: center; align-items: center; padding: 0px 2rem;">
      <div class="p-mb-2"><i class="{{info.icon}}" style="font-size: 40px; color: {{info.color }}"></i></div>
      <div>
        {{info.message}}
        <small style="font-size: 12px;" *ngIf="info.smallMsg"><br />{{info.smallMsg}}</small>
      </div>
    </div>
  </div>
</div>
